import { useEffect, useRef, useState } from 'react';
import { useForecastMap } from './ForecastMapContext';

// Small glass spinner (top-right of the map) while MapLibre is fetching or
// rendering data — basemap tiles, overlay vector tiles, launch sites. Shows
// only when loading drags past 800ms — normal overlay switches resolve faster
// and must not blink a spinner in the corner.
const MapActivityIndicator = () => {
    const map = useForecastMap();
    const [visible, setVisible] = useState(false);
    const timer = useRef(null);

    useEffect(() => {
        if (!map) return undefined;
        const start = () => {
            if (timer.current) return;
            timer.current = setTimeout(() => setVisible(true), 800);
        };
        const stop = () => {
            clearTimeout(timer.current);
            timer.current = null;
            setVisible(false);
        };
        map.on('dataloading', start);
        map.on('idle', stop);
        return () => {
            map.off('dataloading', start);
            map.off('idle', stop);
            clearTimeout(timer.current);
        };
    }, [map]);

    if (!visible) return null;
    return (
        <div className="absolute top-3 right-3 z-[5] w-7 h-7 flex items-center justify-center rounded-full bg-slate-900/60 backdrop-blur-md ring-1 ring-white/10 shadow">
            <span className="w-4 h-4 rounded-full border-2 border-slate-400/40 border-t-blue-400 animate-spin" />
        </div>
    );
};

export default MapActivityIndicator;
